import React from 'react'

const SvgPinOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.56 18.21l-1.15 1.106a2.484 2.484 0 01-3.48-.033l-2.068-2.068-.33-.324-4.702 4.701a1 1 0 01-1.414-1.414l4.689-4.689-.343-.337-2.014-1.974a2.484 2.484 0 01-.023-3.535l1.152-1.152a2.484 2.484 0 012.011-.714l1.81.186 2.49-2.49c-.139-.773.09-1.6.689-2.199l.431-.431c.97-.97 2.543-.97 3.513 0l4.388 4.388c.97.97.97 2.543 0 3.513l-.431.432a2.48 2.48 0 01-2.147.697l-2.51 2.51.186 1.778a2.484 2.484 0 01-.747 2.048zm-3.215-.34c.187.186.488.188.678.006l1.088-1.048c.108-.104.223-.31.207-.458l-.261-2.498a.484.484 0 01.139-.392l3.759-3.76a.482.482 0 01.684 0l.04.041a.484.484 0 00.685 0l.432-.431a.484.484 0 000-.685l-4.389-4.388a.484.484 0 00-.684 0l-.432.432a.484.484 0 000 .684l.071.071a.484.484 0 010 .684l-3.759 3.76a.484.484 0 01-.392.139l-2.527-.26a.484.484 0 00-.392.138L6.14 11.058c-.191.19-.189.5.004.688l2.681 2.613.69.68 2.83 2.83z'
    />
  </svg>
)

export default SvgPinOutline
